export default "__VITE_ASSET__D0jdT3KL__"